const ClientProjectTypes = {
    ADD_CLIENT_PROJECT: 'ADD_CLIENT_PROJECT',
    ADD_CLIENT_PROJECT_LOADING: 'ADD_CLIENT_PROJECT_LOADING',
    ADD_CLIENT_PROJECT_SUCCESS: 'ADD_CLIENT_PROJECT_SUCCESS',
    ADD_CLIENT_PROJECT_ERROR: 'ADD_CLIENT_PROJECT_ERROR',
    ADD_CLIENT_PROJECT_RESET: 'ADD_CLIENT_PROJECT_RESET',

    GET_CLIENT_PROJECTS: 'GET_CLIENT_PROJECTS',
    GET_CLIENT_PROJECTS_LOADING: 'GET_CLIENT_PROJECTS_LOADING',
    GET_CLIENT_PROJECTS_SUCCESS: 'GET_CLIENT_PROJECTS_SUCCESS',
    GET_CLIENT_PROJECTS_ERROR: 'GET_CLIENT_PROJECTS_ERROR',
    GET_CLIENT_PROJECTS_RESET: 'GET_CLIENT_PROJECTS_RESET',
};

export default ClientProjectTypes;
